import React from 'react';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useAlertNotifications } from '../../../hooks';
import AlertNotification from '../AlertNotification/AlertNotification';

import './AlertNotifications.scss';

const AlertNotifications = () => {
  const notifications = useAlertNotifications();

  return (
    <>
      <TransitionGroup component="ul" className="alert-list">
        {notifications.map((notification) => {
          return (
            <CSSTransition
              key={notification.id}
              timeout={500}
              classNames="alert-list__element-"
              appear
              unmountOnExit
            >
              <li className="alert-list__element">
                <AlertNotification data={notification} />
              </li>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </>
  );
};

export default AlertNotifications;
